import { Injectable } from '@angular/core';
import { StorageKeyEnum } from "./storage-key.enum";

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  storage = localStorage;
  constructor() { }

  setItem(key: StorageKeyEnum, value: string) {
    this.storage.setItem(key, value);
  }

  setItemStringify<T>(key: StorageKeyEnum, value: T) {
    this.setItem(key, JSON.stringify(value));
  }

  getItem(key: StorageKeyEnum): string {
    return this.storage.getItem(key) as string;
  }

  getItemParse<T>(key: StorageKeyEnum): T {
    return JSON.parse(this.getItem(key));
  }

  removeItem(key: StorageKeyEnum) {
    this.storage.removeItem(key);
  }
}
